module.exports = __webpack_public_path__ + "img/aub-logo.a77f5850.png";